export default __webpack_public_path__ + "static/our_project-30e2a7c2049313accbbe6c23048a264e.png";